//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'HelloWorld',
  data () {
    return {
      recordsText:'',
      recordsUrl:'',
      processTitle :process.env.VUE_APP_TITLE,
      environment:false

    }
  },
  created(){
    if(this.processTitle==='深圳前海星概念信息技术有限公司'){
      this.recordsText="粤ICP备2023029257号-1"
      this.environment=true
      this.recordsUrl='https://beian.miit.gov.cn/'
    }
    if(this.processTitle==='深圳银顺通小额贷款有限公司'){
      this.recordsText="粤ICP备17011633号-1"
      this.environment=false
      this.recordsUrl='https://beian.miit.gov.cn/'
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/HelloWorld.vue